import { useContext } from 'react'
import BlueProductFlag from 'src/components/restructure/common/BlueProductFlag/BlueProductFlag'
import { ProductContext } from 'src/components/restructure/product/contexts'
import type { Flag } from 'src/components/restructure/product/types/productItem'
import { checkEnviromentIsB2B } from 'src/utils/checkEnviroment'

type GalleryFlagsProps = {
  isPdp?: boolean
}

export const GalleryFlags = ({ isPdp = false }: GalleryFlagsProps) => {
  const { flags } = useContext(ProductContext).currentSku
  const isB2B = checkEnviromentIsB2B()

  if (!flags.length) {
    return null
  }

  const preSaleTagName = 'Pré-venda'
  const hasPreSaleFlag = flags.some(
    (flag: { value: string }) => flag.value === preSaleTagName
  )

  if (hasPreSaleFlag && flags.length === 1) {
    return null
  }

  return (
    <div
      data-testid="gallery-flags"
      className={`${
        !isPdp ? 'absolute' : `relative ${flags.length > 0 ? 'pb-[24px]' : ''}`
      } z-[9] flex gap-2`}
    >
      {flags.slice(0, 2).map((flag: Flag, index: number) => {
        const isBalckFriday = flag?.value.toLowerCase() === 'black friday'

        if (isB2B && flag?.value === 'Oferta Clube Decathlon') {
          return null
        }

        if (flag?.value === preSaleTagName) {
          return null
        }

        if (flag?.value === 'Produto Azul') {
          return isPdp ? null : <BlueProductFlag style="flag" />
        }

        return (
          <div
            key={`${index}`}
            className={`h-[19px] sm:h-[30px] flex gap-[4px] px-[6px] text-[10px] sm:text-xs items-center font-inter leading-[100%] sm:leading-[150%] ${
              isBalckFriday ? 'font-normal' : 'font-medium'
            } w-fit`}
            style={{ backgroundColor: flag?.color, color: flag?.textColor }}
          >
            {flag?.icon && (
              <img
                className="!w-[6px] sm:!w-[12px] h-auto"
                src={flag.icon}
                alt="Flag icon"
              />
            )}
            {flag?.value ?? ''}
          </div>
        )
      })}
    </div>
  )
}
